import React from 'react';
import LocationTemplate from './LocationTemplate';

const HendersonPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Henderson"
      stateName="North Carolina"
      countyName="Vance"
      zipCodes={["27536"]}
      latitude={36.3296}
      longitude={-78.3992}
      population={15005}
      historicalFact="Incorporated in 1841, named after Chief Justice Leonard Henderson; known for its historic tobacco market."
      nearbyTowns={[
        "Oxford, NC",
        "Louisburg, NC",
        "Warrenton, NC",
        "Norlina, NC",
        "Franklinton, NC",
        "Creedmoor, NC",
        "Durham, NC",
        "Wake Forest, NC"
      ]}
    />
  );
};

export default HendersonPage;